import type { LoanRequestInfo } from '@marxbiotech/shared-types/bff';

export const isLoanRequestPending = (
  loanRequest: LoanRequestInfo
): boolean => {
  // 使用 truthy check（而非 === null）避免欄位缺失（undefined）時
  // 被誤判為「非 pending」，進而錯誤顯示取消按鈕
  return !loanRequest.approvedAt && !loanRequest.rejectedAt;
};
